import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { WelcomeComponent } from './views/welcome/welcome.component';
const routes: Routes = [
  { path: '', component: WelcomeComponent },
  { path: 'contact', loadComponent: () => import('./views/contact/contact.component').then(m => m.ContactComponent) },
  { path: 'contact-pqr', loadComponent: () => import('./views/contact-pqr/contact-pqr.component').then(m => m.ContactPqrComponent) },
  { path: 'map', loadComponent: () => import('./views/public-map/public-map.component').then(m => m.PublicMapComponent) },
  { path: 'policies/:policy',loadComponent: () => import('common/pages/policies/policies.component').then(m => m.PoliciesComponent) }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
})
export class LandingRoutingModule {}